import { type InputToggleProps, PROP_MAP } from './interface';

import { Icon } from '../jdsicon/generated';
import { modifyProps } from '../../generators/modifyProps';
import { useSwitch } from '../../hooks/switch';

export const withLogic =
  (
    Component: React.ComponentType<InputToggleProps>
  ): React.FC<InputToggleProps> =>
  (userProps: InputToggleProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const { switchState, onChange } = useSwitch(props.checked);

    return (
      <Component
        {...{
          ...props,

          checked: switchState,
          onClick: (ev: React.ChangeEvent<HTMLInputElement>) => {
            onChange?.(!switchState);
            props.onChange?.({
              ...ev,
              target: {
                ...ev.target,
                value: props.value || '',
                checked: !switchState
              }
            });
          }
        }}
      />
    );
  };

export { InputToggleProps };
